import {ScoresDisplayEventHandler} from "../../../core/handlers/scores.display-event.handler";
import {ScoresListWidgetState} from "../models/scores-list-widget.state";
import {APP} from "../../../core/app/consts";
import {ScoresDisplayEvent} from "../../../core/models/events/scores-display-event";
import {DASHBOARD} from "../../../containers/dashboard-container/dashboard-container.consts";
import {SportViewModel} from "../../../domain/sports/models/sport-view-model";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class ScoresListWidgetDisplayEventHandler extends ScoresDisplayEventHandler {
  state: ScoresListWidgetState;

  async action() {
    const filter = this.state.filterDate
    const displayParams = {
      filter: filter,
      date: DASHBOARD.FILTERS.dateRegEx.test(filter) ? filter : null,
      isLive: DASHBOARD.FILTERS.live,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[SportViewModel.name],
      entityId: this.state.appState.context.sportType?.id,
      showOdds: this.state.appState.showOdds,
      screen: APP.ANALYTICS.SCREENS[this.state.currentLinkModel?.name],
      sportTypeId: this.state.appState.context.sportType?.id,
      matchView: this.state.appState.showAllScores ? ANALYTICS.MATCH_VIEW.allMatches : ANALYTICS.MATCH_VIEW.sortedMatches
    }

    const displayEvent = new ScoresDisplayEvent(displayParams);

    await this.analyticsService.createEvent(displayEvent);
  }
}
